import { render } from "./CampusStudentAttendanceView.vue?vue&type=template&id=23310d20"
import script from "./CampusStudentAttendanceView.vue?vue&type=script&lang=js"
export * from "./CampusStudentAttendanceView.vue?vue&type=script&lang=js"

import "./CampusStudentAttendanceView.vue?vue&type=style&index=0&id=23310d20&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__